import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LayoutService } from './shared/services/layout.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonService } from '@product/shared/services/common.service';
import { take, tap } from 'rxjs';
import { LoginService } from './shared/services/Login.service';
import jwt_decode from 'jwt-decode';
import { LanguageService } from './shared/services/Language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit {
  public isLoggedIn = false;
  selectedLanguage: string = 'en'; 
  userName = '';
  isCollapsed = false;
  innerWidth = window.innerWidth - 48;
  screenSize = '';
  pageTitle = '';
  ngOnInit(): void {
    this.initAppLang();
    const token = localStorage.getItem('token');
    if (token) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
    const tokenData = jwt_decode(token!, { header: false }) as any;
    this.userName = tokenData.name;
    this.layoutService.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });


    setTimeout(() => {
      if (!this.router.url.includes('auth/')) {
        this.commonService
          .getLanguages()
          .pipe(
            tap((response) => {
              this.loginService.loginStatus.next(true);
              this.commonService.dropDownMetaData['languages'] =
                response.value.map((lang) => {
                  return {
                    Code: lang.Id,
                    Label: lang.Name,
                    Additional: {
                      isoCode: lang.Isocode,
                      isDefault: lang.IsDefault,
                    },
                  };
                });
              if (response.value.find((x) => x.IsDefault === true) == null) {
                this.commonService.dropDownMetaData['languages'].push({
                  Code: 0,
                  Label: 'Default',
                  Additional: 'DEFAULT',
                });
              }
            })
          )
          .subscribe();
      }
    }, 100);
  }
  constructor(
    public layoutService: LayoutService,
    private loginService: LoginService,
    breakpointObserver: BreakpointObserver,
    private commonService: CommonService,
    private authService: LoginService,
    private router: Router,
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    breakpointObserver.observe([Breakpoints.XLarge]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'x-large';
        document.body.className = '';
        document.body.classList.add(this.screenSize);
      }
    });
    breakpointObserver.observe([Breakpoints.Large]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'large';
        document.body.className = '';
        document.body.classList.add(this.screenSize);
      }
    });
    breakpointObserver.observe([Breakpoints.Medium]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'medium';
        document.body.className = '';
        document.body.classList.add(this.screenSize);
      }
    });
    breakpointObserver.observe([Breakpoints.Small]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'small';
        document.body.className = '';
        document.body.classList.add(this.screenSize);
      }
    });
    breakpointObserver.observe([Breakpoints.XSmall]).subscribe((result) => {
      if (result.matches) {
        this.screenSize = 'x-small';
        document.body.className = '';
        document.body.classList.add(this.screenSize);
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth - 48;
  }



  logout() {
    this.authService.logout().subscribe(() => this.authService.clearTokens());
  }
 
  changeLanguage(lang: string) {
    localStorage.setItem('app_lang', lang);
    this.languageService.setLanguage(lang);
  }
  private initAppLang(): void {
    
    const savedLang = localStorage.getItem('app_lang') || 'en';
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);
  }
   
}
